import { z } from "zod"
import { baseSchema, schemaToJson } from "../schema-utils.js"

const DbPostSchema = z.strictObject({
  ...baseSchema.shape,
  root_id: z.string().nullable(),
  latest: z.boolean(),
  title: z.string().nullable(),
  description: z.string().nullable(),
  json: z.string(),
  published_at: z.date().nullish(),
  archived_at: z.date().nullable(),
  sent_at: z.date().nullish(),
  created_at: z.date(),
  image_header_url: z.string().nullable(),
  pinned_at: z.date().nullable(),
  canonical_url: z.string().nullable(),
  meta_title: z.string().nullable(),
  meta_description: z.string().nullable(),
  bookmark_id: z.string().nullish(),
})
export type DbPost = z.infer<typeof DbPostSchema>

export const PostSchema = schemaToJson(DbPostSchema)
export type Post = z.infer<typeof PostSchema>
